import $ from "jquery";
import CellSelectionType from "./CellSelectionType";
import DateSelectionType from "./DateSelectionType";
import TableMouseEventsHandler from "../table/TableMouseEventsHandler";
import LockTableCellSelectionState from "./LockTableCellSelectionState";
import ColumnSelectionState from "./ColumnSelectionState";
import DelayedSelectionState from "./DelayedSelectionState";
import LockTableRangeSelectedState from "./LockTableRangeSelectedState";
import LockTableHoverState from "./LockTableHoverState";
import {getEventObj, whichButtonPressed} from "../atBrowserUtils"
import IgnoreMouseEventsState from "./IgnoreMouseEventsState";

export default class LockTableMouseEventsHandler extends TableMouseEventsHandler {
    constructor(table, selectionController, hoverController, runnerController) {
        super(table, selectionController, hoverController);
        this.runnerController = runnerController;
        this.cellSelectionState = new LockTableCellSelectionState(this);
        this.columnSelectionState = new ColumnSelectionState(this);
        this.delayedSelectionState = new DelayedSelectionState(this);
        this.rangeSelectedState = new LockTableRangeSelectedState(this);
        this.hoverState = new LockTableHoverState(this);
        this.state = this.hoverState;
        this.selectionFinishedListeners = [];
        this.ignoreMouseEvents = false;

        //should handle mouseUp which occurs beyond table borders
        let self = this;
        let prevMouseUp = document.onmouseup;
        $(document).mouseup(function(evt) {
            if (prevMouseUp)
                prevMouseUp.call(this, evt);
            self.mouseUp(evt, null);
        });
    }

    mouseOver(evt, cell) {
        this.state.mouseOver(evt, cell);
    }

    mouseOut(evt, cell) {
        this.state.mouseOut(evt, cell);
    }

    mouseDown(evt, cell) {
        if (this.isLeftButton(evt))
            this.state.mouseDown(evt, cell);
    }

    mouseUp(evt, cell) {
        if (this.isLeftButton(evt))
            this.state.mouseUp(evt, cell);
    }

    mouseMove(evt, cell) {
        this.state.mouseMove(evt, cell);
    }

    isLeftButton(evt) {
        return whichButtonPressed(getEventObj(evt)) == "left";
    }

    getRunnerController() {
        return this.runnerController;
    }

    setIgnoreMouseEvents(ignore) {
        if (ignore && !this.ignoredState) {
            this.ignoredState = this.state;
            this.state = new IgnoreMouseEventsState(this);
        }
        else if (!ignore && this.ignoredState) {
            if (this.selectionController.hasSelection()) {
                this.state = this.ignoredState;
                this.ignoredState = undefined;
            }
            else {
                this.ignoredState = undefined;
                let lastHoveredCell = this.state.lastHoveredCell;
                this.setHoverState();
                if (lastHoveredCell)
                    this.mouseOver(null, lastHoveredCell);
            }
        }
    }

    setCellSelectionState(anchorCell) {
        this.getSelectionController().setSelectionAnchor(anchorCell);
        this.getSelectionController().setSelectionType(new CellSelectionType());
        this.state = this.cellSelectionState;
    }

    setColumnSelectionState(anchorCell) {
        this.getSelectionController().setSelectionAnchor(anchorCell);
        this.getSelectionController().setSelectionType(new DateSelectionType());
        this.getSelectionController().changeSelectionTo(anchorCell.getRow().getTable().getLastSelectableRow().getCell(anchorCell.getColIdx()));
        this.state = this.columnSelectionState;
    }

    setHoverState() {
        this.state = this.hoverState;
    }

    setDelayedSelectionState(stateSwitcher) {
        this.delayedSelectionState.setDelayedStateSwitcher(stateSwitcher);
        this.state = this.delayedSelectionState;
    }

    setRangeSelectedState() {
        this.state = this.rangeSelectedState;
    }


    addSelectionFinishedListener(listener) {
        this.selectionFinishedListeners.push(listener);
    }

    fireSelectionFinished(mouseUpEvent) {
        for (let i = 0; i < this.selectionFinishedListeners.length; i++)
            this.selectionFinishedListeners[i].call(this.selectionFinishedListeners[i], mouseUpEvent);
    }
}



// WEBPACK FOOTER //
// ./web/js/locktable/LockTableMouseEventsHandler.js